module.exports = __webpack_public_path__ + "img/shop-img-5.4d5732d0.png";